import Link from '@risksmart-app/components/src/link';
import { colours } from '@risksmart-app/components/src/utils/colours';
import { LinkExternal01 } from '@untitled-ui/icons-react';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { toLocalDate } from 'src/utils/dateUtils';

import SimpleRatingBadge from '../simple-rating-badge';

export interface Props {
  id: string;
  reference?: string | null;
  regulatoryBody?: string | null;
  effectiveDate?: string | null;
  externalLink?: string | null;
  onClick?: (id: string) => void;
}

const InformationBox: FC<Props> = ({
  id,
  reference,
  effectiveDate,
  regulatoryBody,
  externalLink,
}) => {
  const { t } = useTranslation(['common'], { keyPrefix: 'obligations' });

  return (
    <div
      className={
        'p-4 bg-white border-grey150 border-solid border-2 rounded-md flex gap-2 text-sm'
      }
      key={`lr-${id}`}
    >
      <div className={'grid grid-cols-2 gap-4 w-full'}>
        <span className={'font-semibold text-gray-400'}>
          {`${t('external_obligation.regulatory_body')}:`}
        </span>
        <span className={'flex justify-end'}>
          <SimpleRatingBadge
            rating={{
              label: regulatoryBody ?? '-',
              color: colours['light-gray'].backgroundColor,
            }}
          />
        </span>

        <span
          className={'font-semibold text-gray-400'}
        >{`${t('external_obligation.reference')}:`}</span>

        {externalLink ? (
          <Link
            className={'!flex !justify-end'}
            href={externalLink}
            target={'_blank'}
            rel={'noopener noreferrer'}
          >
            {reference ?? '-'}&nbsp; <LinkExternal01 width={14} height={14} />
          </Link>
        ) : (
          <span className={'flex justify-end'}>{reference ?? '-'}</span>
        )}

        <span className={'font-semibold text-gray-400'}>
          {`${t('columns.EffectiveDate')}:`}
        </span>
        <span className={'flex justify-end'}>{toLocalDate(effectiveDate)}</span>
      </div>
    </div>
  );
};

export const SourceRegulationInformation: FC<Props> = ({
  onClick,
  id,
  reference,
  effectiveDate,
  regulatoryBody,
  externalLink,
}) => {
  return (
    <div
      className={`p-5 bg-off_white rounded-md flex flex-col gap-4 justify-items-start`}
    >
      <span className={'m-0 font-semibold text-grey500'}>
        {'Source Regulation Information'}
      </span>
      <InformationBox
        onClick={onClick}
        id={id}
        reference={reference}
        effectiveDate={effectiveDate}
        regulatoryBody={regulatoryBody}
        externalLink={externalLink}
      />
    </div>
  );
};

export default SourceRegulationInformation;
